import {useIntl} from 'react-intl';
import {useMessages} from 'react-chatbotify';
import {useGlobalContext, useUserContext} from '../../contexts';
import {MessagesHelper} from '../../utils';

type UseSubmitChatHistory = () => {
  submitChatHistory: () => Promise<void>;
}

export const useSubmitChatHistory: UseSubmitChatHistory = () => {
  const chat = useMessages();
  const intl = useIntl();
  const {user} = useUserContext();
  const {api} = useGlobalContext();

  const submitChatHistory = async () => {
    const lastCloseFlowMessage = intl.formatMessage({
      id: 'flow-msg-assistant-preparing-recommendations',
      defaultMessage: 'Wait a minute! I am preparing recommendations just for you!'
    });
    const messages = MessagesHelper.getAIAssistantFlowMessages(
      chat.messages,
      lastCloseFlowMessage,
    )
      .filter(msg => msg.type === 'string')
      .filter(msg => msg.content !== lastCloseFlowMessage)
      .map(msg => (
        {
          id: msg.id,
          timestamp: msg.timestamp,
          content: msg.content.toString(),
          sender: msg.sender,
        }
      ));
    await api.sendChatHistoryByEmail(user.contactID, messages);
  };

  return {submitChatHistory};
};
